<div class="pt-2">
    <div *ngIf="isLoading; else content">
        <div class="d-flex justify-content-center py-2">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <ng-template #content>
        <div *ngIf="!updateMode" class="mx-2">
            <h4><i class="fa-solid fa-stopwatch text-primary-color"></i> Dodaj licznik wody:</h4>
        </div>
        <form [ngClass]="{'pt-2': updateMode}" [formGroup]="waterMeterForm">
            <mat-form-field class="three-quarters-width mt-2 mx-2" appearance="outline">
                <mat-label>Typ:</mat-label>
                <mat-select formControlName="type">
                    <mat-option [value]="'hot'">gorąca</mat-option>
                    <mat-option [value]="'cold'">zimna</mat-option>
                </mat-select>
            </mat-form-field>
            <ng-container *ngIf="type.value">
                <mat-form-field class="three-quarters-width mt-2 mx-2" appearance="outline">
                    <mat-label>Numer licznika:</mat-label>
                    <input matInput formControlName="number" name="number" type="text"
                           placeholder="Numer licznika"
                           #meterNumber>
                    <mat-hint align="end">
                        {{ meterNumber.value.length }} / {{ meterNumberMaxLength }}
                    </mat-hint>
                    <mat-error *ngIf="number.errors?.['required']">
                        Podaj numer licznika.
                    </mat-error>
                    <mat-error
                        *ngIf="number.value.length < meterNumberMinLength && !number.errors?.['required']">
                        Minimalna długość wynosi {{ meterNumberMinLength }} znaków.
                    </mat-error>
                    <mat-error *ngIf="number.value.length > meterNumberMaxLength">
                        Maksymalna długość wynosi  {{ meterNumberMaxLength }} znaków.
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="three-quarters-width mt-2 mx-2" appearance="outline">
                    <mat-label>Stan licznika:</mat-label>
                    <input matInput formControlName="counter" name="counter" type="text"
                           placeholder="Stan licznika"
                           #meterCounterNumber>
                    <mat-hint align="end">
                        {{ meterCounterNumber.value.length }} / {{ meterCounterNumberMaxLength }}
                    </mat-hint>
                    <mat-error *ngIf="counter.errors?.['required']">
                        Podaj stan licznika.
                    </mat-error>
                    <mat-error
                        *ngIf="counter.value.length < meterCounterNumberMinLength && !number.errors?.['required']">
                        Minimalna długość wynosi {{ meterCounterNumberMinLength }} znaków.
                    </mat-error>
                    <mat-error *ngIf="counter.value.length > meterCounterNumberMaxLength">
                        Maksymalna długość wynosi{{ meterCounterNumberMaxLength }} znaków.
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="three-quarters-width mt-2 mx-2" appearance="outline">
                    <mat-label>Numer plomby radiowej:</mat-label>
                    <input matInput formControlName="radio_overlay_number" name="radio_overlay_number" type="text"
                           placeholder="Radio overlay number"
                           #overlayNumber>
                    <mat-hint align="end">
                        {{ overlayNumber.value.length }} / {{ radioOverlayNumberMaxLength }}
                    </mat-hint>
                    <mat-error *ngIf="radioOverlayNumber.errors?.['required']">
                        Podaj numer plomby radiowej.
                    </mat-error>
                    <mat-error
                        *ngIf="radioOverlayNumber.value.length < radioOverlayNumberMinLength && !number.errors?.['required']">
                        Minimalna długość wynosi {{ radioOverlayNumberMinLength }} znaków.
                    </mat-error>
                    <mat-error *ngIf="radioOverlayNumber.value.length > radioOverlayNumberMaxLength">
                        Maksymalna długość wynosi {{ radioOverlayNumberMaxLength }} znaków.
                    </mat-error>
                </mat-form-field>
            </ng-container>
        </form>
    </ng-template>
</div>
<app-save-button [invalid]="waterMeterForm.invalid"
                 (closeForm)="closeFormEmit()"
                 (save)="addWaterMeter()"
                 [addMode]="!updateMode">
</app-save-button>
